import React, { ChangeEvent, Fragment, ReactElement, useEffect, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Box, Backdrop, CircularProgress, TextField, Button, Typography, Grid2 } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers';
import { importArticles } from '../../redux/actions/articleActions';
import { useAppDispatch } from '../../hooks/hooks';
import ArticlesTable from './ArticlesTable';
import ArticleForm from './ArticleForm';
import { DetailsContainerBox, DetailsTableContainerBox } from '../../common/ResponsiveStyle';

export default function ArticlesList(): ReactElement {
    const articles = useSelector((state: RootState) => state.articles.articles);
    const [filter, setFilter] = React.useState<string>('');

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!articles) {
            dispatch(importArticles());
        }
    }, [dispatch]);

    const handleFilterChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setFilter(value);
    };

    const [openArticleForm, setOpenArticleForm] = useState<boolean>(false);

    const goToForm = () => {
        setOpenArticleForm(true);
    };

    const handleCloseArticleForm = () => {
        setOpenArticleForm(false);
    };

    const filteredArticles = articles?.filter(
        (a) =>
            a.innerCode?.toLowerCase().includes(filter.toLowerCase()) ||
            a.outterCode?.toLowerCase().includes(filter.toLowerCase()) ||
            a.title?.toLowerCase().includes(filter.toLowerCase()) ||
            a.manufacturer?.toLowerCase().includes(filter.toLowerCase()) ||
            !!a.labels?.find((l) => l.title?.toLowerCase().includes(filter.toLowerCase())),
    );

    return articles === null ? (
        <Fragment>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={!Boolean(articles)}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </Fragment>
    ) : (
        <DetailsContainerBox
            sx={{
                p: 2,
                backgroundColor: (theme) => (theme.palette.mode === 'light' ? 'white' : theme.palette.grey[900]),
            }}
        >
            <Grid2 container sx={{ py: 2, px: { xs: 2, sm: 4 }, justifyContent: 'space-between', gap: 2 }}>
                <Grid2>
                    <Typography variant="h5">Artikli</Typography>
                </Grid2>
                <Grid2>
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={goToForm}
                        startIcon={<AddIcon />}
                        sx={{ textTransform: 'none' }}
                    >
                        Novi artikal
                    </Button>
                </Grid2>
            </Grid2>
            <hr />
            <Box sx={{ p: { xs: 1, sm: 4 }, pt: 2 }}>
                <TextField
                    size="small"
                    sx={{ mb: 1, width: '100%' }}
                    placeholder="Filter"
                    value={filter}
                    onChange={handleFilterChange}
                />
                <Box sx={{ p: 0, mt: 2 }}></Box>
                <DetailsTableContainerBox>
                    <ArticlesTable articles={filteredArticles ?? null} />
                </DetailsTableContainerBox>
            </Box>
            <ArticleForm closeForm={handleCloseArticleForm} open={openArticleForm} articleId={undefined} />
        </DetailsContainerBox>
    );
}
